module.exports = __webpack_public_path__ + "img/wfzjl.6732e1f7.png";